import { DisclosureContent } from "types/graphql/generated";

interface Disclosures {
  data: (
    | {
        attributes: DisclosureContent;
      }
    | undefined
  )[];
}

export { DisclosuresContext } from "./DisclosuresContext";
export { DisclosuresProvider } from "./DisclosuresProvider";
export type { Disclosures };
